import React from 'react';
//import { BrowserRouter as Router, Route, Switch, NavLink } from 'react-router-dom';
import AdminGalleryCreate from './AdminGalleryCreate';
import AdminGalleryEdit from './AdminGalleryEdit';

export default class AdminGallery extends React.Component {

  render() {
    return (
      <div className='card text-left'>
          <h5 className="card-header">Admin Gallery Page</h5>
          <div className='card-body'>
            <ul className="nav nav-pills mb-3" id="pills-tabd" role="tablist">
                <li className="nav-item">
                    <a className="nav-link active" id="pills-createg-tab" data-toggle="pill" href="#pills-createg" role="tab" aria-controls="pills-createg" aria-selected="true">Create</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" id="pills-editg-tab" data-toggle="pill" href="#pills-editg" role="tab" aria-controls="pills-editg" aria-selected="false">Edit</a>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabcContent">
                <div className="tab-pane fade show active" id="pills-createg" role="tabpanel" aria-labelledby="pills-createg-tab">
                  <AdminGalleryCreate/>
                </div>
                <div className="tab-pane fade" id="pills-editg" role="tabpanel" aria-labelledby="pills-editg-tab">
                  <AdminGalleryEdit {...this.props} />
                </div>
            </div>
          </div>
      </div>
    )
    }
  };